// extracted by css-extract-rspack-plugin
export default {"loader":"loader-iCvbNl"};